import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FloorsService } from 'src/app/features/restaurants/services/Floors.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';
import { Record } from 'src/app/features/restaurants/models/Floors';

export interface DialogData {
  record: Record,
  restaurantId: number,
  stopUpdate: boolean
}
@Component({
  selector: 'app-floor-form',
  templateUrl: './floor-form.component.html'
})
export class FloorFormComponent extends DirtyComponent implements OnInit {

  override formGroup!: FormGroup;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.record ? true : false;

  constructor(
    override dialogRef: MatDialogRef<FloorFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    translate: TranslateService,
    private service: FloorsService,
    public router: Router
  ) { super(translate) }

  ngOnInit(): void {
    this.buildForm();
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      title_EN: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.enTxtWithSpecial),
        Validators.required
      ]],
      title_AR: [null, [
        CustomValidator.noWhiteSpace,
        Validators.maxLength(50),
        // Validators.pattern(Patterns.arTxtWithSpecial),
        Validators.required
      ]],
      restaurantsId: [this.data.restaurantId]
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  bindDataToUpdate() {
    this.formGroup.patchValue({
      title_EN: this.data.record.title_EN,
      title_AR: this.data.record.title_AR,
      restaurantsId: this.data.restaurantId
    });
  }


  saveRecord() {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        id: '',
        title_EN: this.formGroup.controls['title_EN'].value,
        title_AR: this.formGroup.controls['title_AR'].value,
        restaurantsId: this.data.restaurantId,
      };

      if (this.data.stopUpdate) {
        this.loading = false;
        this.dialogRef.close(data);
        return;
      }

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.id = this.data.record.id;
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.saveRecord(data).subscribe((response: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        if (!this.isUpdate) {
          Swal.fire({
            title: this.translate.instant('planner.The floor created successfully'),
            imageUrl: './assets/images/Waiters-amico.svg',
            showCancelButton: false,
            confirmButtonText: this.translate.instant('swalMsg.I got it'),
          })
          this.router.navigate(['/admin/floorPlan'], { queryParams: { id: response.id } });
        }
        else {
          Swal.fire({
            title: this.translate.instant('swalMsg.updatedsuccessfully'),
            imageUrl: './assets/images/Waiters-amico.svg',
            showCancelButton: false,
          })
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }
}
